import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink, RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import { RecertificationDateComponent } from "@serasa/core/modules/recertification/components/recertification-date/recertification-date.component";
import { UserMe } from "@serasa/core/modules/recertification/interfaces/user-me.interface";
import { CompanyInfo } from "@serasa/core/modules/users/interfaces/company-info.interface";
import {
  selectCompanyInfo,
  selectUserMeInfo,
} from "@serasa/core/modules/users/state/selectors/user.selectors";
import { SharedModule } from "@serasa/shared/shared.module";
import { Observable, Subscription } from "rxjs";

@Component({
    imports: [
        CommonModule,
        RecertificationDateComponent,
        SharedModule,
        RouterLink,
        RouterModule,
    ],
    selector: "pl-business-info",
    templateUrl: "business-info.component.html",
    styleUrls: ["./business-info.component.scss"],
    standalone: true,
})
export class BusinessInfoComponent implements OnInit, OnDestroy {
  public userMeInfo$!: Observable<UserMe | null | undefined>;
  public companyInfo?: CompanyInfo;
  public showBackButton?: boolean;
  public info$?: Observable<CompanyInfo | undefined>;

  private _subs: Subscription[] = [];

  constructor(
    public store: Store,
    private readonly route: ActivatedRoute,
  ) {
    this.getCompanyInfo();
    this.checkActiveRoute();
  }

  ngOnInit() {
    this.userMeInfo$ = this.store.select(selectUserMeInfo);
  }

  checkActiveRoute() {
    this.showBackButton = this.route.snapshot.url[0]?.path !== "dashboard";
  }

  getCompanyInfo() {
    this.info$ = this.store.select(selectCompanyInfo);
  }

  ngOnDestroy() {
    for (const sub of this._subs) {
      sub.unsubscribe();
    }
  }
}
